import { CLASS_CONSTATNTS as TYPES } from '../../organizedByType/actions/analyticsActions'
import { isMenuOpen } from './menu.selectors'

export const TOGGLE_MENU = '[menu] toggle menu'
export function toggleMenuAction() {
  return {
    type: TOGGLE_MENU,
  }
}

function sendMenuButtonClickAnalyticsAction(action) {
  return {
    type: TYPES.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Navigation',
        action: `hamburger menu ${action ? 'open' : 'close'}`,
        label: 'none',
      },
    },
  }
}

export const toggleMenu = () => (dispatch, getState) => {
  dispatch(toggleMenuAction())
  dispatch(sendMenuButtonClickAnalyticsAction(isMenuOpen(getState())))
  setTimeout(function() {
    if (window.__cmp) {
      window.__cmp('uspPing', null, function(obj, status) {
        if (status && (obj.location === 'ca' || obj.location === 'CA')) {
          window.__cmp('setUspDftData', 1, function(obj, status) {})
          let menu = document.getElementsByClassName('menu__static__links__container')
          menu[0].childNodes[menu[0].childNodes.length - 1].insertAdjacentHTML(
            'afterend',
            `<a class="menu__static__link__container" onclick="window.__cmp('displayUspUi')" class="items-list__link" href="#">Do Not Sell My Info</a>`
          )
        }
      })
    }
  }, 100)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/menu/menu.actions.js